import { type Store, createLens } from '@frontend/viewer-core';

import type { DxfSessionState, OverlayManager, OverlayState } from './types';

export const createOverlaysSlice = (
  state: Store<DxfSessionState>,
): Store<OverlayState> =>
  createLens(
    state,
    (current) => current.overlays,
    (current, overlays) => ({ ...current, overlays }),
  );

type Dependencies = {
  overlays: Store<OverlayState>;
};

export const createOverlayController = ({
  overlays,
}: Dependencies): OverlayManager => ({
  getState: overlays.getState,
  subscribe: overlays.subscribe,
  set(key, isOn) {
    overlays.setState((previous) =>
      previous[key] === isOn ? previous : { ...previous, [key]: isOn },
    );
  },
  toggle(key) {
    overlays.setState((previous) => ({
      ...previous,
      [key]: !previous[key],
    }));
  },
});
